module.exports = "/_next/static/images/main-visual-idea-842ebc6209922fe30c4e02799887960b.jpg";